<widget-section
  [title]="title"
  [displayTitle]="displayTitle"
  [widgets]="widgets"
>
</widget-section>
